import { ExtensionShopifyClient } from "@redotech/shopify-client/ajax";
import {
  addFavoriteProductCache,
  checkForFavoriteProductCache,
  removeFavoriteProductCache,
} from "./favorite-product-button-cache";
import { FavoriteProductManager } from "./favorite-product-manager";

export class NotLoggedInFavoriteProductManager extends FavoriteProductManager {
  private storefrontClient: ExtensionShopifyClient;
  constructor(storefrontClient: ExtensionShopifyClient) {
    super();
    this.storefrontClient = storefrontClient;
  }

  private async getDefaultProductVariantId(
    handle: string,
  ): Promise<string | null> {
    const product = await this.storefrontClient.productGet(handle);
    const defaultVariant = product.variants[0]?.id;
    return defaultVariant ? String(defaultVariant) : null;
  }

  async isFavoriteProduct(
    handle: string,
    variantId: string | null,
  ): Promise<boolean> {
    if (!variantId) {
      variantId = await this.getDefaultProductVariantId(handle);
    }
    const cacheResult = checkForFavoriteProductCache({
      handle,
      variantId,
      userLoggedIn: false,
    });

    return !!cacheResult;
  }

  async addFavoriteProductWithDefaultVariant(
    handle: string,
    variantId: string | null,
  ): Promise<void> {
    if (!variantId) {
      variantId = await this.getDefaultProductVariantId(handle);
    }
    addFavoriteProductCache(handle, variantId);
  }

  addFavoriteProduct(handle: string, variantId: string | undefined): void {
    addFavoriteProductCache(handle, variantId ?? null);
  }

  async removeFavoriteProduct(
    handle: string,
    variantId: string | null,
  ): Promise<void> {
    if (!variantId) {
      variantId = await this.getDefaultProductVariantId(handle);
    }
    removeFavoriteProductCache(handle, variantId);
  }

  isLoggedIn(): boolean {
    return false;
  }
}
